<template lang="html">
  <div class="page-container">
    <div class="page-container__header">
      <h1 class="header-1 page-container__title">
        Programări
      </h1>
      <div class="page-container__header__list-type">
        <i
          class="fas fa-list-ul"
          :class="{ active: appointmentsAppearance === 'list' }"
          @click="changeAppointmentsAppearance('list')"
        />
        <i
          class="fas fa-border-all"
          :class="{ active: appointmentsAppearance === 'grid' }"
          @click="changeAppointmentsAppearance('grid')"
        />
      </div>
    </div>
    <div class="page-container__body">
      <div class="page__notice">
        <i class="fas fa-info-circle"></i> Pentru a vizualiza programările anterioare, vizitați pagină               <router-link class="dropdown__item" 
                :to="`/${ role }/appointments/history`" tag="span">Istoric Programări</router-link>.
      </div>
      <div
        class="page__wrapper"
        :class="{ 'page__wrapper--list': appointmentsAppearance === 'list' }"
        v-if="appointmentsLoading"
      >
        <AppointmentCard :appearance="appointmentsAppearance" :skeleton="true" />
        <AppointmentCard :appearance="appointmentsAppearance" :skeleton="true" />
        <AppointmentCard :appearance="appointmentsAppearance" :skeleton="true" />
      </div>

      <template v-else-if="appointments.length === 0">
        <UiNewCard
          title="Programare noua"
          path="/specialists"
          v-if="role === 'client'"
        />
        <p v-else style="margin-top: 20px;">
          Nu ai nicio programare în curs momentan
        </p>
      </template>

      <div class="page__wrapper" :class="{ 'page__wrapper--list': appointmentsAppearance === 'list' }" v-else>
        <template v-for="(appointment, index) of feed">
          <h2 class="page__header" v-if="appointment.time !== undefined" :key="'pg-' + index">
            {{ calendar(appointment.time) }}
          </h2>
          <AppointmentCard
            v-else
            :key="appointment.id"
            :appearance="appointmentsAppearance"
            :appointment="appointment"
            @openJoinMeeting="$emit('openJoinMeeting')"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import UiNewCard                  from '@/components/ui/NewCard';
import AppointmentCard            from './components/AppointmentCard';

export default {
  components: {
    AppointmentCard,
    UiNewCard
  },
  mounted() {
    this.fetchAppointments();
  },
  computed: {
    ...mapGetters({
      appointments           : 'appointments/appointments',
      appointmentsAppearance : 'appointments/appointmentsAppearance',
      appointmentsLoading    : 'appointments/appointmentsLoading',
      user                   : 'user/user',
    }),

    feed() {
      const object = {};

      for (const appointment of this.appointments) {
        const timeStampStart = this.$moment(appointment.start_timestamp);
        const daytime = timeStampStart.format('YYYY-MM-DD');

        object[daytime] ??= [];
        object[daytime].push(appointment);
      }

      let feed = [];

      for (const daytime in object) {
        feed.push({ time: daytime });
        feed = feed.concat(object[daytime]);
      }

      return feed;
    },

    role() {
      return this.user.role || 'client';
    },
  },
  methods: {
    ...mapActions({
      changeAppointmentsAppearance : 'appointments/changeAppointmentsAppearance',
      fetchAppointments            : 'appointments/fetchAppointments',
    }),

    calendar(timestamp) {
      return this.$moment(timestamp, "YYYY-MM-DD").calendar().split(' la', 2)[0];
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/pages/appointments';
</style>
